import { useContext } from 'react';
import AppContext, { IAppContext } from './AppContext';

export default function useAppContext(): IAppContext {
  const appContext: IAppContext = useContext(AppContext);

  return { ...appContext };
}
